<template>
  <svg
    class="custom-icon"
    width="52"
    height="36"
    viewBox="0 0 52 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.53088 11.5431V36C1.80493 34.5787 0 32.7727 0 32.0075V8.53389C2.51607 10.1753 5.46781 10.887 8.53088 11.5431Z"
      fill="#CFCDF7"
    />
    <path
      d="M51.9442 8.53383V32.0053C51.9442 32.7704 50.1394 34.5764 43.4133 35.9999V11.543C46.3672 10.8869 49.4279 10.1753 51.9442 8.53383Z"
      fill="#CFCDF7"
    />
    <path
      d="M42.2667 1.36786C37.5636 0.491556 31.9315 0 25.9721 0C20.0127 0 14.3809 0.491578 9.73326 1.36786C2.07832 2.79132 0 4.70633 0 5.52705C0 6.34777 2.02265 8.31837 9.73326 9.73963C10.1711 9.84863 10.5534 10.2312 10.5534 10.7249V29.6015C15.0366 28.8342 20.3397 28.396 25.9721 28.396C31.6045 28.396 36.9077 28.7786 41.4466 29.5459V10.723C41.4466 10.2314 41.7755 9.84671 42.2667 9.73772C49.9217 8.31426 52 6.39925 52 5.52513C51.9445 4.70441 49.9218 2.78918 42.2667 1.36786ZM19.5753 7.00182C20.9423 7.00182 22.0914 8.09611 22.0914 9.51957C22.0914 10.943 20.9423 12.0373 19.5753 12.0373C18.2084 12.0373 17.0593 10.943 17.0593 9.51957C17.0593 8.09611 18.2084 7.00182 19.5753 7.00182ZM38.1659 23.4162H13.7783V19.8042L19.1906 14.3883C19.4085 14.1703 19.7929 14.1703 20.0108 14.3883L24.6584 19.039L31.9312 11.7614C32.149 11.5434 32.5335 11.5434 32.7513 11.7614L38.1636 17.1773L38.1659 23.4162Z"
      fill="#CFCDF7"
    />
  </svg>
</template>
